var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.97 29.0428L33.87 13.0807L23.7403 80.5892L49.0801 94.9383L78.1756 93.7344L99.97 29.0428Z",
    fill: "#E65100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5116 26.8941L50.5355 88.9115L73.8119 87.9484L92.146 33.3259L65.5116 26.8941Z",
    fill: "#FF6D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5305 59.9441L59.4084 52.1677L76.1278 56.2051L69.368 78.2338L52.7889 79.5797L54.7606 71.4144L63.3888 70.6175L66.0846 62.0098L57.5305 59.9441ZM78.589 48.5695L81.0501 40.9339L63.1642 36.6147L61.2863 44.3912L78.589 48.5695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7607 71.4144L52.7889 79.5797L38.651 70.8162L40.4555 59.9358L48.2319 61.8136L47.4471 66.7678L54.7607 71.4144ZM51.7602 42.0908L61.2864 44.3912L63.1643 36.6147L45.4728 32.3425L41.2 56.0006L57.5306 59.9441L59.4085 52.1677L50.4655 50.0081L51.7602 42.0908Z",
    fill: "#EEEEEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(22.6085 0.0738525) rotate(13.5761)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.576a3d01c3a739a88103f02bf0924b1f.svg";
export { ForwardRef as ReactComponent };